import axios from "axios";
import { BASE_URL } from "@/service_urls";

// The switch itself takes about 15-45 s server-side; leave room before giving up on the answer.
const SWITCH_TIMEOUT_MS = 90000;

const dbSwitch = {
  getStatus: () => axios.get(`${BASE_URL}/admin/db-switch`),
  switchDatabase: (database) =>
    axios.post(
      `${BASE_URL}/admin/db-switch/switch`,
      { database, confirmName: database },
      { timeout: SWITCH_TIMEOUT_MS },
    ),
};

export default dbSwitch;
